import { Directive, Input, ElementRef, OnChanges, SimpleChanges } from '@angular/core';

@Directive({ selector: '[treeDragEnabled]',
  standalone: false })
export class TreeDragEnabledDirective implements OnChanges {
  @Input('treeDragEnabled') enabled: boolean | (() => boolean);

  constructor(private el: ElementRef<HTMLElement>) {}

  ngOnChanges(changes: SimpleChanges) {
    try {
      const val = typeof this.enabled === 'function' ? (this.enabled as any)() : !!this.enabled;
      if (val) {
        this.el.nativeElement.setAttribute('draggable', 'true');
      } else {
        this.el.nativeElement.removeAttribute('draggable');
      }
    } catch (e) {
      // ignore
    }
  }
}
